import { FC } from 'react';
import FilterDropdown, { FilterOption } from '../../../components/custom-input/FilterDropdown';
import { ANIMAL_CONSTANTS, BUTTON_CONSTANTS, LABEL_CONSTANTS } from '../../../constants/common';
import { filtersType } from '../../inventory/Inventory';

interface OnFarmFilterControlsProps {
  filters: filtersType;
  setFilters: (filters: filtersType) => void;
  typeOptions: FilterOption<number | null>[];
  speciesOptions: FilterOption<number | null>[];
  breedOptions: FilterOption<number | null>[];
  sortOptions: FilterOption<string | null>[];
  handleGetBreedOptions: (speciesId: number) => void;
  isModal?: boolean;
  onCancel?: () => void;
}

const OnFarmFilterControls: FC<OnFarmFilterControlsProps> = ({
  filters,
  setFilters,
  typeOptions,
  speciesOptions,
  breedOptions,
  sortOptions,
  handleGetBreedOptions,
  isModal = false,
  onCancel,
}) => {
  return (
    <>
      <div className="filter-option">
        <label>{LABEL_CONSTANTS.SPECIMEN_TYPE}</label>
        <FilterDropdown
          placeholder="All"
          options={typeOptions}
          value={filters.type}
          onChange={type => setFilters({ ...filters, type })}
        />
      </div>
      <div className="filter-option">
        <label>{ANIMAL_CONSTANTS.SPECIES}</label>
        <FilterDropdown
          placeholder="All"
          options={speciesOptions}
          value={filters.species}
          onChange={species => {
            handleGetBreedOptions(species.value);
            setFilters({ ...filters, species, breed: { name: '', value: null } });
          }}
        />
      </div>
      <div className="filter-option">
        <label>{ANIMAL_CONSTANTS.BREED}</label>
        <FilterDropdown
          placeholder="All"
          options={breedOptions}
          value={filters.breed}
          onChange={breed => setFilters({ ...filters, breed })}
        />
      </div>
      <div className="filter-option">
        <label>{LABEL_CONSTANTS.SORT_BY}</label>
        <FilterDropdown
          placeholder="All"
          options={sortOptions}
          value={filters.sort}
          onChange={sort => setFilters({ ...filters, sort })}
        />
      </div>
      {isModal && onCancel && (
        <div className="footer">
          <button type="button" className="button green inverted mr-1" onClick={onCancel}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          <button type="submit" className="button green">
            {BUTTON_CONSTANTS.APPLY}
          </button>
        </div>
      )}
    </>
  );
};

export default OnFarmFilterControls;
